import $ from 'jquery';

let searchAutocompleteContainer = $('.search-suggestions');
let darkenBody = $('.darken-body');

let timeout = 0;

let get_suggestions = function (input, auto) {
	darkenBody.hide();

	$.ajax({
		dataType: "json",
		url: gwoon_theme_vars.rest_routes.search_suggestions,
		cache: false,
		data: {
			data: input.val()
		},
		method: 'GET',
		success: function (response) {
			if (response.data === undefined) {
				auto.hide();
				auto.empty();
				darkenBody.hide();
				return;
			}

			let data = response.data;

			if (data.length === 0) {
				auto.hide();
				auto.empty();
				darkenBody.hide();
				return;
			}

			auto.html(data);
			darkenBody.show();
			auto.show();
		},
		error: function () {
			auto.hide();
		}
	});
};

//Input van het zoeken
$(document).on('input', '.search-input', function() {
	let searchContainer = $('.header-search');
	let searchAutocompleteContainer = searchContainer.find('.search-suggestions');
	darkenBody.hide();

	searchAutocompleteContainer.hide();
	clearTimeout(timeout);
	if ($(this).val().length > 2) {
		timeout = setTimeout( () => {
			get_suggestions( $( this ), searchAutocompleteContainer );
		}, 200 );
	}
});


$(document).on('input', '.header-search__input', function() {

	let searchReset = $(this).parent().find('.header-search__reset');

	if ($(this).val().length > 0) {
		searchReset.show()
	} else {
		searchReset.hide()
	}

});

$( document ).ready( function () {
	let searchInput = $('.header-search__input');

	searchInput.each(function () {

		if ($(this).val().length > 0) {
			$(this).parent().find('.header-search__reset').show();
		}
	});

});


$('.header-search__reset').on('click', function () {
	$(this).parent().find('.header-search__input').val('');
	$(this).hide();
});



// Sluit de resultaten als er buiten het zoekvenster wordt geklikt.
$('body').on('click', function (element) {
	if (searchAutocompleteContainer.is(":hidden")) {
		return;
	}
	if (element.target.id === "search")
		return;
	//For descendants of .header__search-wrapper-input being clicked
	if ($(element.target).closest('.header-search__input').length)
		return;

	darkenBody.hide();
	searchAutocompleteContainer.hide();
});

//goto function
let navigation = {
	goToSection: function(id, offset) {
		$('html, body').animate({
			scrollTop: $(id).offset().top -offset
		}, 0);
	}
}

//Op mobiel: scroll to input field.
$('body').on('click', function (element) {
	if (element.target.id === "search") {
		if ($( window ).width() < 640) {
			navigation.goToSection('#' + element.target.id, $('.sticky-container').height() + 10);
		}
	}
});

let headerSearchWrapper = $('.header-search__wrapper-menu');
let toggleDesktopHeaderSearch = $('#toggle-desktop-header-search');

toggleDesktopHeaderSearch.on('click', function () {
	headerSearchWrapper.show();
});


// Sluit de zoekbalk als buiten zoekbalk click.
$('body').on('click', function (element) {
	if ($(element.target).closest('.top-bar-desktop-search').length) {
		return;
	}

	headerSearchWrapper.hide();
});

